import { render, staticRenderFns } from "./QuestionTag.vue?vue&type=template&id=1799599a&scoped=true"
import script from "./QuestionTag.vue?vue&type=script&lang=ts"
export * from "./QuestionTag.vue?vue&type=script&lang=ts"
import style0 from "./QuestionTag.vue?vue&type=style&index=0&id=1799599a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799599a",
  null
  
)

export default component.exports